module.exports = __webpack_public_path__ + "img/jose.c5f35284.png";